import { Injectable, signal } from '@angular/core';

/** A small application-wide surface for API errors that need user feedback. */
@Injectable({ providedIn: 'root' })
export class ApiErrorService {
  readonly message = signal<string | null>(null);

  show(message: string): void {
    this.message.set(message);
  }

  clear(): void {
    this.message.set(null);
  }
}
